
Monet.Tooltip = {
    /**
     * Utilizada para adicionar o Tooltip ao elemento html
     *
     * @param tooltip = {selector: "",my: "",at: "",text: "",classe: "", showEvent: fn}
     *
     *
     */

    getTooltipParams: function (tooltip) {
        const image = require("static/images/general/loading_blue.svg");
        var contentInitial = '<img src="' + image + '" width="30" height="30" alt="loader"/>';
        var width = (tooltip.width) ? tooltip.width : "380";
        return {
            overwrite: true,
            position: {
                my: tooltip.my || 'right center',
                at: tooltip.at || 'center left',
                target: tooltip.target ? $(tooltip.target) : $(tooltip.selector),
                effect: "FALSE",
                adjust: {
                    target: tooltip.target ? $(tooltip.target) : $(tooltip.selector),
                    method: "flip shift",
                    x: (tooltip.adjust && tooltip.adjust.x) ? tooltip.adjust.x : 0,
                    y: (tooltip.adjust && tooltip.adjust.y) ? tooltip.adjust.y : 0
                },
                viewport: tooltip.viewport || $("#page_container"),
                container: tooltip.container || $('#Maps')
            },
            content: {
                text: tooltip.text || contentInitial,
                title: {
                    text: 'notificationPanel.title',
                    button: Monet.I18n.getResourcesByKey('default.button.close')
                }

            },
            style: {
                classes: tooltip.classe ? tooltip.classe : "notificationWindow ui-tooltip-light",
                width: width
            },
            show: {
                event: (tooltip.eventToShow === false || tooltip.eventToShow) ? tooltip.eventToShow : "click",
                effect: false,
                solo: tooltip.solo || true
            },
            hide: {
                event: "click mousewheel"
            },
            events: {
                show: function () {

                    Monet.Session.WindowNotification.selector = tooltip.selector;
                    Monet.Session.WindowNotification.elementId = tooltip.elementId;
                    // funcao a ser executada
                    if (tooltip.showEvent) {
                        tooltip.showEvent();
                    }

                },
                hide: function () {
                    if (Monet.Session.WindowNotification.selector === tooltip.selector) {
                        Monet.Session.WindowNotification.selector = undefined;
                    }

                    if (Monet.Session.WindowNotification.elementId === tooltip.elementId) {
                        Monet.Session.WindowNotification.elementId = undefined;
                    }

                    if (tooltip.hide) {
                        tooltip.hide();
                    }

                },
                hidden: function () {
                    $(".formCloseEvent").html("");

                    const elementsTooltip = $(tooltip.selector).qtip().elements ?
                        $(tooltip.selector).qtip().elements.tooltip : null;

                    if (elementsTooltip) {
                        $(elementsTooltip).css("width", width);
                    }

                    Monet.Tooltip.expandTooltip(tooltip.selector, width);
                }
            }
        };
    },

    addTooltip: function (tooltip) {
        if (tooltip.selector) {
            $(tooltip.selector).qtip(this.getTooltipParams(tooltip));
        }
    },

    addTooltipToElement: function (tooltip) {
        if (tooltip.element) {
            $(tooltip.element).qtip(this.getTooltipParams(tooltip));
        }
    },


    /**
     * Atualiza a posicao do tooltip
     *
     * @param elementId:
     *            o id do elemento alvo html
     */
    updatePositionTooltip: function (selector) {
        var api = $(selector).data('qtip');
        if (api) {
            api.set('position.target', selector);
        }
    },
    updateContentTooltip: function (element, content) {
        var api = $(element).data('qtip');
        if (api) {
            api.set('content.text', content);
        }
    },
    hideTooltip: function (element) {
        var api = $(element).data('qtip');
        if (api) {
            api.hide();
        }
    },
    expandTooltip: function (element, width) {
        var api = $(element).data('qtip');
        if (api) {

            api.set("style.max-width", "none");
            api.set("style.width", width);

            if (api.get("position.at").indexOf("left") === 0) {
                api.set("style.left", -width);
            }
        }
    },
    toDown: function (element, size) {
        var api = $(element).data('qtip');
        if (api) {
            api.set("style.top", size);

        }
    },
    show: function (element) {
        var api = $(element).data('qtip');
        if (api) {
            api.show();
        }
    }
};
